<!-- 接收情况列表 -->
<template>
  <div class="notice-receive">
    <van-tabs v-model="active" style="height:100%" >
      <van-tab :title="isNeedConfirm ? `未确认（${num1}）` : `未读（${num1}）`" name="1">
        <div class="list-wrapper">
          <list-child :status="1" :isNeedConfirm="isNeedConfirm" :uploadCount="n=>num1 = n" ref="child1" @refresh="refreshList($refs.child2)" ></list-child>
        </div>
      </van-tab>
      <van-tab :title="isNeedConfirm ? `已确认（${num2}）` : `已读（${num2}）`" name="2">
        <div class="list-wrapper">
          <list-child :status="2" :isNeedConfirm="isNeedConfirm" :uploadCount="n=>num2 = n" ref="child2" @refresh="refreshList($refs.child1)" ></list-child>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import listChild from './receive-child.vue';
export default {
  name: 'notice-receive',
  data() {
    return {
      pageTitle: '家长接收情况',
      active: '2',
      isNeedConfirm: false,
      num1: 0,
      num2: 0,
    };
  },
  computed: {},
  methods: {
    refreshList(instance){
      instance.doRefresh();
    },
  },
  created() {
    this.isNeedConfirm = +this.$route.query.isNeedConfirm;
    this.$api.noticeInfo(+this.$route.params.id).then(res => {
      if (res.code == 200) {
        this.$refs.child1.alreadySend = res.data.remindStatus == 3;
        this.$refs.child1.lastRemindTime = res.data.lastRemindTime;
        this.$refs.child1.getDetail = true;
      }
    });
  },
  mounted(){
    setTimeout(() => {
      this.active = '1';
    }, 0);
  },
  beforeDestroy() {},
  components: {
    listChild
  },
};
</script>

<style lang="scss" scoped>
.notice-receive {
  display: flex;
  flex-direction: column;
  .list-wrapper{
    height: calc(100vh - 44px);
  }
}
</style>
